import { Injectable } from '@angular/core';
import { ApiClass } from '@data/class/api-class';
import { IResponseArray } from '@data/interfaces/iresponseArray.interface';
import { environment } from '@env/environment';
import { IWalletList } from '../../interfaces/iwalllet.interface';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '@data/services/modules/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ApiAdminWalletService extends ApiClass {
    wallet: any = {}
  
    constructor(private readonly authService: AuthService) {
      super();
      this.path = 'wallet';
    }
  
    getAll(page = 1, limit = 10, filters = {}) {
      filters = {
        ...filters,
        status: { value: 'Activo', matchMode: 'equals' },
      };
  
      return this.http.post<IResponseArray>(environment.apiUrl + this.path, { page, limit, filters }).pipe(
        map((r) => r as IWalletList),
        catchError(() => of({ error: true, data: [], total: 0 } as IWalletList))
      );
    }

    getAdminWalletAmounts() {
      return this.http.post<{ data: any }>(`${environment.apiUrl}${this.path}/adminAmounts`, {})
        .pipe(
          map(response => response.data || []),
          catchError(() => of([]))
        );
    }
}
